import { useQuery } from '@tanstack/react-query'
import { useTypedApiClient } from 'hooks/useTypedApiClient'

export const useGetAllLocationSweepstakeWinners = () => {
  const get = useTypedApiClient({
    path: '/admin/sweepstake-winners/locationSweepstakeWinners',
    method: 'get',
  })

  return useQuery({
    queryKey: ['/admin/sweepstake-winners/locationSweepstakeWinners'],
    queryFn: async () => {
      const { data } = await get({})
      return data
    },
  })
}
